import qs from 'qs';

import { apiUrl } from '../envUtil';
import { APIRequest } from '../apiUtil';
import { Mixpanel } from 'utils/mixPanelUtil';
import { DataTableQueryType } from 'types/base';

export const getTransactionTasks = (contract_id: number, params?: string) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + `transaction/${contract_id}/tasks` + (params ? `?${params}` : ''),
    });
};

export const getTransactionTaskLists = (contract_id: number, params?: DataTableQueryType) => {
    return APIRequest({
        method: 'get',
        url:
            apiUrl +
            `transaction/${contract_id}/tasklists` +
            (params ? `?${qs.stringify(params)}` : ''),
    });
};

export const getAllTasks = (params?: string) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + `tasks` + (params ? `?${params}` : ''),
    });
};

export const addNewTask = (
    contract_id: number,
    payload: any,
    formType: 'FULL' | 'PARTIAL' = 'PARTIAL'
) => {
    Mixpanel.track('app.add_transaction_task', {
        contract_id,
        ...payload,
    });

    return APIRequest({
        method: 'post',
        url: apiUrl + `transaction/${contract_id}/task?formType=${formType}`,
        data: {
            ...payload,
        },
        useDefaultErrorNotif: true,
    });
};

export const updateTask = (
    contract_id: number,
    id: number,
    payload: any,
    formType: 'FULL' | 'PARTIAL' = 'PARTIAL'
) => {
    Mixpanel.track('app.edit_transaction_task', {
        contract_id,
        task_id: id,
        action: 'edit',
        ...payload,
    });

    return APIRequest({
        method: 'put',
        url: apiUrl + `transaction/${contract_id}/task/${id}?formType=${formType}`,
        data: {
            ...payload,
        },
        useDefaultErrorNotif: true,
    });
};

export const deleteTask = (contract_id: number, id: number) => {
    Mixpanel.track('app.delete_transaction_task', {
        contract_id,
        task_id: id,
    });

    return APIRequest({
        method: 'delete',
        url: apiUrl + `transaction/${contract_id}/task/${id}`,
        useDefaultErrorNotif: true,
    });
};

export const getTaskDetail = (contract_id: number, id: number) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + `transaction/${contract_id}/task/${id}`,
        useDefaultErrorNotif: true,
    });
};

export const linkTasksToDocs = (contract_id: number, taskIDs: number[], docIDs: number[]) => {
    Mixpanel.track('app.edit_transaction_task', {
        contract_id,
        action: 'link-to-docs',
        task_ids: taskIDs,
        doc_ids: docIDs,
    });

    return APIRequest({
        method: 'post',
        url: apiUrl + `transaction/${contract_id}/tasks/link-to-docs`,
        data: {
            doc_ids: docIDs,
            task_ids: taskIDs,
        },
    });
};

export const addNewTasklist = (contract_id: number, payload: any) => {
    Mixpanel.track('app.add_transaction_tasklist', {
        contract_id,
        ...payload,
    });

    return APIRequest({
        method: 'post',
        url: apiUrl + `transaction/${contract_id}/tasklist`,
        data: {
            ...payload,
        },
        useDefaultErrorNotif: true,
    });
};

export const updateTasklist = (contract_id: number, id: number, payload: any) => {
    Mixpanel.track('app.edit_transaction_tasklist', {
        contract_id,
        tasklist_id: id,
        action: 'edit',
        ...payload,
    });

    return APIRequest({
        method: 'put',
        url: apiUrl + `transaction/${contract_id}/tasklist/${id}`,
        data: {
            ...payload,
        },
        useDefaultErrorNotif: true,
    });
};

export const deleteTasklist = (contract_id: number, id: number) => {
    Mixpanel.track('app.delete_transaction_tasklist', {
        contract_id,
        tasklist_id: id,
    });

    return APIRequest({
        method: 'delete',
        url: apiUrl + `transaction/${contract_id}/tasklist/${id}`,
        useDefaultErrorNotif: true,
    });
};

export const moveTasksToTasklist = (
    contract_id: number,
    task_ids: number[],
    tasklist_id: number
) => {
    Mixpanel.track('app.update_transaction_tasks', {
        contract_id,
        action: 'move-to-tasklist',
        task_ids: task_ids,
        tasklist_id: tasklist_id,
    });

    return APIRequest({
        method: 'put',
        url: apiUrl + `transaction/${contract_id}/tasks/tasklist`,
        data: {
            task_ids: task_ids,
            tasklist_id: tasklist_id,
        },
        useDefaultErrorNotif: true,
    });
};

// Bulk task update auto send email
export const bulkUpdateTaskAutoSendEmail = (
    contract_id: number,
    task_ids: number[],
    auto_send_email: boolean
) => {
    Mixpanel.track('app.update_transaction_tasks', {
        contract_id,
        action: 'update-auto-send-email',
        task_ids: task_ids,
        auto_send_email: auto_send_email,
    });

    return APIRequest({
        method: 'put',
        url: apiUrl + `transaction/${contract_id}/tasks/auto-send-email`,
        data: {
            task_ids: task_ids,
            auto_send_email: auto_send_email,
        },
        useDefaultErrorNotif: true,
    });
};

// Bulk task delete
export const bulkDeleteTasks = (contract_id: number, task_ids: number[]) => {
    Mixpanel.track('app.delete_transaction_tasks', {
        contract_id,
        action: 'delete-tasks',
        task_ids: task_ids,
    });

    return APIRequest({
        method: 'delete',
        url: apiUrl + `transaction/${contract_id}/tasks`,
        data: {
            task_ids: task_ids,
        },
        useDefaultErrorNotif: true,
    });
};
